import * as CommonAPI from '@/api/common';
import { makeTree } from '@/libs/utils';

export default {
  data() {
    return {
      area: [],
      // 地区列表
      areaList: [],
      areaListObject: {},

      // 国家列表
      countryList: [],
    };
  },

  created() {
    this.getAreaList();
  },

  methods: {
    getCountryList(areaId) {
      // 国家列表
      if (
        this.areaListObject &&
        areaId &&
        this.areaListObject[areaId] &&
        this.areaListObject[areaId].children
      ) {
        this.countryList = this.areaListObject[areaId].children;
      } else {
        this.countryList = this.area.filter(item => item.pid !== 0);
      }
    },

    // 获取地区列表
    getAreaList() {
      // 判断session storage里是否存在
      const areaList = window.sessionStorage.getItem('areaList');
      const areaListObject = window.sessionStorage.getItem('areaListObject');
      if (areaList && areaListObject) {
        return new Promise((resolve, _reject) => {
          this.areaList = JSON.parse(areaList);
          this.areaListObject = JSON.parse(areaListObject);

          // 所有国家
          this.getCountryList();

          resolve(this.areaList, this.areaListObject);
        });
      }

      return CommonAPI.AreaListAll().then(res => {
        if (res.code === 0) {
          this.area = res.data;
          const _list = makeTree({
            data: res.data,
            idName: 'id',
            parentIdName: 'pid',
          });
          // console.log('_list', _list);
          this.areaList = _list.array;
          this.areaListObject = _list.object;

          window.sessionStorage.setItem('areaList', JSON.stringify(this.areaList));
          window.sessionStorage.setItem('areaListObject', JSON.stringify(this.areaListObject));

          // 所有国家
          this.getCountryList();
        }
      });
    },

    areaChange(fn) {
      this.form.regionId = undefined;

      // 国家列表
      this.getCountryList(this.form.areaId);

      // 回调
      if (typeof fn === 'function') {
        fn && fn();
      }
    },
  },
};
